import './AboutBackground.css'

const AboutBackground = () => {
    return (
        <div className="absolute bg-white w-full h-full z-[-1] overflow-hidden">
            <div className="blob5" />
            <div className="blob6" />
        </div>
    )
}

export default AboutBackground